module.exports = __webpack_public_path__ + "57e471ad7d1a83c731c70f03b8282acf.png";